import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
import { STORAGE_KEY } from './PaymentReturnScreen';
import { appPath } from '../routes/appPaths';

export default function PaymentFailedScreen() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const hallPid = params.get('hall');

  const handleRetry = () => {
    sessionStorage.removeItem(STORAGE_KEY);
    if (hallPid) {
      navigate('/menu', { replace: true });
      return;
    }
    navigate(appPath('/checkout'), { replace: true });
  };

  const handleOrders = () => {
    sessionStorage.removeItem(STORAGE_KEY);
    navigate(appPath('/orders'), { replace: true });
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6" style={{ background: '#0a0a0a' }}>
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        className="text-center max-w-sm w-full"
      >
        <XCircle size={72} className="mx-auto mb-4" style={{ color: '#f87171' }} strokeWidth={1.5} />
        <h2 className="text-2xl font-bold text-white mb-2">Оплата не прошла</h2>
        <p className="text-sm mb-8" style={{ color: 'rgba(255,255,255,0.45)' }}>
          Попробуйте ещё раз или выберите другой способ оплаты
        </p>
        <button
          type="button"
          onClick={handleRetry}
          className="w-full rounded-xl py-3 text-sm font-semibold text-black mb-3"
          style={{ background: '#fff' }}
        >
          Попробовать снова
        </button>
        <button
          type="button"
          onClick={handleOrders}
          className="w-full rounded-xl py-3 text-sm font-semibold text-white border border-white/20"
        >
          К заказам
        </button>
      </motion.div>
    </div>
  );
}
